<template>
  <div class="container">
    <div class="col-xs-12" style="margin-top:1em;">
      <router-link class="pull-right" to="/campaigns">Volver a la lista</router-link>
    </div>
    <ul class="nav nav-tabs">
      <li role="presentation" class="active">
        <a href="#general" aria-controls="general" role="tab" data-toggle="tab">Nueva campaña</a>
      </li>
      <li role="presentation">
        <a href="#preguntas" aria-controls="general" role="tab" data-toggle="tab">Preguntas</a>
      </li>
      <li role="presentation" v-if="camp._id">
        <a href="#stats" aria-controls="general" role="tab" data-toggle="tab">Resultados</a>
      </li>
    </ul>
    <div class="box-style line-top">
      <div class="tab-content">
        <div class="tab-pane active in fade" role="tabpanel" id="general">
          <form class="form smart-form">
            <div class="box-body">
              <div class="row">
                <div class="col-xs-12">
                  <div class="form-group">
                    <label for="">Nombre</label>
                    <div class="input">
                      <input type="text" class="form-control" v-model="camp.name">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div class="form-group">
                    <label>Desde</label>
                      <date-picker v-model="camp.fechaInicio" :default-date="camp.fechaInicio"></date-picker>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-xs-12 col-md-12">
                  <label>EMPRESAS <a @click="agregarTodasLasEmpresas" style="cursor:pointer;" class="disable-filter">Agregar todas</a></label>
                  <br/>                  
                  <select class="form-control select2 filter-select2" ref="slEmpresasActiva" multiple style="width:100%" data-select2-container="big-text">
                    <option v-for="empresa in empresas" :selected="camp.empresasSelect.indexOf(empresa._id)>=0" :key="empresa._id" :value="empresa._id">{{empresa.razonSocial}}</option>
                  </select>
                  <a @click="quitarTodasLasEmpresas" style="cursor:pointer;" class="disable-filter hide" :class="{show: camp.empresasSelect.length > 0}">Quitar empresas</a>                  
                </div>            
                <div class="form-group col-xs-12 col-md-12">
                  <label>SUCURSALES <a @click="agregarTodasLasSucursales" style="cursor:pointer;" class="disable-filter">Agregar todas</a></label>
                  <br/>                  
                  <select class="form-control select2 filter-select2" ref="slSucursalesActiva" multiple style="width:100%" data-select2-container="big-text">
                    <option v-for="suc in sucursalesParaSelect" :selected="camp.sucursalesSelect.indexOf(suc._id)>=0" :key="suc._id" :value="suc._id">{{suc.denominacion}} - {{suc.empresa.razonSocial}}</option>
                  </select>
                  <a @click="quitarTodasLasSucursales" class="disable-filter hide" style="cursor:pointer;" :class="{show: camp.sucursalesSelect.length > 0}">Quitar sucursales</a>
                </div>

              </div>
              <div class="row" style="margin-top:30px;">
                  <div class="text-center center-block">
                    <button class="btn btn-fill" @click.prevent="onGuardarCampaign()">Guardar Campaña</button>
                  </div>
              </div>           
            </div>
          </form>
        </div>
        <div class="tab-pane in fade" role="tabpanel" id="preguntas">
          <div class="row"  v-for="preg in preguntas">
                <div class="col-md-12 col-sm-12 col-xs-12">
                      <div class="form-group">
                        <span>
                            <i class="fa fa-check-square-o"></i>
                        </span>
                        {{preg.pregunta}}
                      </div>
                </div>
          </div>
        </div>
        <div class="tab-pane in fade" role="tabpanel" id="stats">
          <div class="row">
            <div class="col-md-4 text-center">
              <h4><b>{{camp.name}}</b></h4>
              <h4>Alcance : <b>{{reach}}</b></h4>
            </div>
            <div class="col-md-4 text-center">
              <h4>Creada: <b>{{camp.fechaCreacion | formatearFecha}}</b></h4>
              <h4>Vigente desde: <b>{{camp.fechaInicio | formatearFecha}}</b></h4>
            </div>
            <div class="col-md-4 text-center">
              <h4>
                <span class="label label-success" v-if="camp.activo">Activa</span>
                <span class="label label-danger" v-else>Inactiva</span>
              </h4>
              <h4>Respuestas : <b>{{answers}}</b></h4>
            </div>
          </div>
          <div class="row filtersSearchStats">
            <div class="form-group col-xs-12 col-sm-4" style="padding-left:20px;">
              <label>EMPRESAS</label>
              <br/>                  
              <select class="form-control select2 filter-select2" ref="slEmpresa" multiple style="width:100%" data-select2-container="big-text">
                <option v-for="empresa in camp.empresas" :key="empresa._id" :value="empresa._id">{{empresa.razonSocial}}</option>
              </select>
              <a @click="quitarFiltrosEmpresa" class="disable-filter hide" :class="{show: filtros.empresas.length > 0}">Quitar filtro empresas</a>
            </div>            
            <div class="form-group col-xs-12 col-sm-4" style="padding-left:20px;">
              <label>SUCURSALES</label>
              <br/>                  
              <select class="form-control select2 filter-select2" ref="slSucursal" multiple style="width:100%" data-select2-container="big-text">
                <option v-for="suc in sucursalesParaFiltro" :key="suc._id" :value="suc._id">{{suc.denominacion}}</option>
              </select>
              <a @click="quitarFiltrosSucursal" class="disable-filter hide" :class="{show: filtros.sucursales.length > 0}">Quitar filtro sucursales</a>
            </div>
            <div class="form-group col-xs-12 col-sm-4">
                  <label>EXPORTAR RESPUESTAS</label>
                  <br/>
                  <button class="btn btn-outline-grey-green" @click="exportXls(true)" data-toggle="tooltip" rel="tooltip" data-placement="top" data-original-title="Exportar agrupadas por pregunta" title="Exportar agrupadas por pregunta">
                    EXCEL <i class="fa fa-cubes"></i>
                  </button>
                  <button class="btn btn-outline-grey-green" @click="exportXls(false)" data-toggle="tooltip" rel="tooltip" data-placement="top" data-original-title="Exportar en forma atómica" title="Exportar en forma atómica">
                    EXCEL <i class="fa fa-cube"></i>
                  </button>
                  <button class="btn btn-outline-grey-green" @click="exportPdf()">
                    PDF
                  </button>
            </div>
          </div>
          <div class="row">
          </div>
          <div class="row">
          <ul class="nav nav-tabs">
            <li role="presentation" class="active">
              <a href="#resume" aria-controls="results-stats" role="tab" data-toggle="tab">Resumen</a>
            </li>
            <li role="presentation">
              <a href="#data" aria-controls="results-stats" role="tab" data-toggle="tab">Datos</a>
            </li>
          </ul>
          <div class="box-style line-top">
            <div class="tab-content">
              <div class="tab-pane active in fade" role="tabpanel" id="resume">
                <div class="row">
                <div class="col-md-4 text-center" v-for="(result, idx) in preguntasFiltradas">
                  <div class="row piegraph" :class="result.preguntaId">
                    <span style="min-height:40px; display:block; position:relative; top:20px; z-index:1000;"><b>{{result.pregunta}}</b></span>
                  <graph-pie
                          :width="250"
                          :height="250"
                          :values="result.values"
                          :names="result.names"
                          :show-text-type="'inside'"
                          :colors="[ '#93A512', '#74A9B3', '#F28893']"
                          :data-format="dataFormat">
                      <legends :names="result.names"></legends>
                  </graph-pie>
                  </div>
                </div>
                </div>
              </div>
            <div class="tab-pane in fade" role="tabpanel" id="data">
                <div class="panel-group smart-accordion-default" v-for="question in preguntas">
                    <div class="panel-heading">
                      <div class="panel-title box-header">
                        <a data-toggle="collapse" :href="'#question' + question._id">
                          <i class="fa fa-lg fa-angle-down pull-right"></i>
                          <i class="fa fa-lg fa-angle-up pull-right"></i>
                          <h2><b>{{question.pregunta}}</b></h2>
                          <button class="pull-right btn btn-sm btn-outline-grey-green" @click="exportXls(true, question)" data-toggle="tooltip" rel="tooltip" data-placement="top" data-original-title="Exportar agrupadas por pregunta" title="Exportar agrupadas por pregunta">
                            EXCEL <i class="fa fa-cubes"></i>
                          </button>
                          <button class="pull-right btn btn-sm btn-outline-grey-green" @click="exportPdf(question)">
                            PDF
                          </button>
                      </a>
                      </div>
                    </div>
                    <div :id="'question' + question._id" class="panel-collapse collapse in">
                      <table class="table">
                        <thead>
                          <tr>
                            <th>Nick</th>
                            <th>Email</th>
                            <th>Usuario</th>
                            <th>Empresa - Sucursal</th>
                            <th>Respuesta</th>
                            <th>Fecha</th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr v-for="res in resultsGroupedByQuestion[question._id]">
                              <td>{{res.usuario.username}}</td>
                              <td>{{res.usuario.email}}</td>
                              <td>{{res.usuario.displayName}}</td>
                              <td>{{res.usuario.sucursalAsociada.empresa.razonSocial}} - {{res.usuario.sucursalAsociada.denominacion}}</td>
                              <td>{{ getRespuesta(res) }}</td>
                              <td>{{res.fechaCreacion | formatearFecha}}</td>
                            </tr>
                        </tbody>
                      </table>                    
                    </div>
                </div>
            </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden" ref="contenedorExport"></div>
  </div>

</template>
<script>
import '../../assets/css/select2_status.css'
import '../../assets/css/select2.css'
import {minLength, required} from 'vuelidate/lib/validators'
import 'sweetalert2/dist/sweetalert2.css'
import swal from 'sweetalert2'
import $ from 'jquery'
import { findIndex, cloneDeep, filter, flatMap, sortBy, groupBy } from 'lodash'
import DatePicker from '../Shared/DatePicker'
import moment from 'moment'
import 'select2'
import canvg from 'canvg'
import JsPDF from 'jspdf'
import 'jspdf-autotable'
import TableExport from 'tableexport'

export default {
  components: {
    'date-picker': DatePicker
  },
  props: ['maps-loaded'],
  filters: {
    subsidioATexto (value) {
      return `L:${value.lunes}%, M:${value.martes}%, X:${value.miércoles}%, J:${value.jueves}%, V:${value.viernes}%, S:${value.sábado}%`
    },
    formatearFecha (value) {
      return moment(new Date(value)).format('DD/MM/YYYY')
    }
  },
  data () {
    return {
      results: [],
      resultsGroupedByQuestion: [],
      allResults: [],
      answers: 0,
      reach: 0,
      usuarioActivo: undefined,
      errors: [],
      guardadoBD: false,
      idSucursalEdicion: false,
      nombreSucursalEdicion: '',
      mostrarErroresUsuario: true,
      loadingSucursales: false,
      empresas: [],
      preguntas: [],
      campActiva: undefined,
      empresaActiva: undefined,
      filtros: {
        empresas: [],
        sucursales: []
      },
      camp: {
        _id: null,
        name: '',
        empresas: [],
        sucursales: [],
        preguntas: [],
        fechaInicio: undefined,
        empresasSelect: [],
        sucursalesSelect: []
      },
      cliente: {
        _id: null,
        razonSocial: ''
      },
      sucursal: {
        _id: null,
        denominacion: '',
        proveedoresAsociados: [],
        proveedores: [],
        subsidio: {
          comboAsignado: null,
          lunes: 0,
          martes: 0,
          miércoles: 0,
          jueves: 0,
          viernes: 0,
          sábado: 0,
          domingo: 0
        }

      },
      asignacion: {
        comboSeleccionado: null,
        horarioSeleccionado: null,
        proveedorActivo: null
      },
      direccion: {
        direccion: '',
        direccionFormateada: '',
        latitud: 0,
        longitud: 0,
        torre: '',
        piso: '',
        departamento: ''
      },
      usuario: {
        firstName: '',
        lastName: '',
        email: '',
        area: '',
        username: '',
        password: '',
        repeat: '',
        telefonoFijo: '',
        telefonoCelular: '',
        interno: ''
      },
      editandoSucursalGuardada: false,
      editandoProveedorSucursal: false,
      idxSucursalEditada: -1,
      mostrarErroresProveedor: false,
      proveedorSeleccionado: null,
      proveedores: [],
      sucursales: [],
      usuarios: []
    }
  },
  validations: {
    camp: {
      name: {
        required,
        minLength: minLength(3)
      },
      fechaInicio: {
        required
      },
      sucursales: {
        minLength: minLength(1)
      },
      empresas: {
        minLength: minLength(1)
      }
    }
  },
  mounted () {
    const me = this
    me.$http.get('/api/admin/campaigns/init', {
      params: {
        id: me.$route.params.id || null
      }
    }).then(({body}) => {
      me.empresas = body.empresas
      me.preguntas = sortBy(body.preguntas, ['orden'])
      me.sucursales = body.sucursales
      if (body.campaign) {
        me.camp = body.campaign
        me.camp.fechaInicio = moment(me.camp.fechaInicio).toDate()
        me.camp.fechaFin = moment(me.camp.fechaFin).toDate()
        me.camp.empresasSelect = flatMap(me.camp.empresas, (empresa) => { return empresa._id })
        me.camp.sucursalesSelect = flatMap(me.camp.sucursales, (suc) => { return suc._id })
        me.$http.get('/api/admin/campaigns/results', {
          params: {
            id: me.$route.params.id || null
          }
        }).then(({body}) => {
          me.allResults = body.results
          me.answers = body.answers
          me.reach = body.reach
        })
      }
      $(me.$refs.slEmpresasActiva).select2({
        placeholder: 'Seleccione Empresas'
      }).on('change', (e) => {
        let nuevasEmpresasIds = $(me.$refs.slEmpresasActiva).val()
        let nuevasEmpresas = filter(me.empresas, (emp) => { return me.camp.empresasSelect.indexOf(emp._id) < 0 && nuevasEmpresasIds.indexOf(emp._id) >= 0 })
        let nuevosIds = flatMap(nuevasEmpresas, (emp) => { return emp._id })
        me.camp.empresasSelect = nuevasEmpresasIds
        me.camp.empresas = filter(me.empresas, (emp) => { return me.camp.empresasSelect.indexOf(emp._id) >= 0 })
        let sucsParaAgregar = filter(me.sucursales, (suc) => { return nuevosIds.indexOf(suc.empresa._id) >= 0 })
        sucsParaAgregar.forEach((suc) => {
          me.camp.sucursalesSelect.push(suc._id)
        })
      })
      $(me.$refs.slSucursalesActiva).select2({
        placeholder: 'Seleccione Sucursales'
      }).on('change', (e) => {
        me.camp.sucursalesSelect = $(me.$refs.slSucursalesActiva).val()
      })
      $(me.$refs.slEmpresa).select2({
        placeholder: 'Seleccione Empresas'
      }).on('change', (e) => {
        me.filtros.empresas = $(me.$refs.slEmpresa).val()
      })
      $(me.$refs.slSucursal).select2({
        placeholder: 'Seleccione Sucursales'
      }).on('change', (e) => {
        me.filtros.sucursales = $(me.$refs.slSucursal).val()
      })
    })
  },
  computed: {
    sucursalesParaSelect () {
      const me = this
      if (me.camp.empresas.length > 0) {
        let ret = filter(me.sucursales, (suc) => {
          return me.camp.empresasSelect.indexOf(suc.empresa._id) >= 0
        })
        return ret
      }
      return []
    },
    sucursalesParaFiltro () {
      const me = this
      if (me.filtros.empresas.length > 0) {
        return filter(me.camp.sucursales, (suc) => {
          return me.filtros.empresas.indexOf(suc.empresa) >= 0
        })
      } else {
        return me.camp.sucursales
      }
    },
    preguntasFiltradas () {
      const me = this
      let sucs = []
      if (me.filtros.sucursales.length > 0) {
        sucs = me.filtros.sucursales
      } else if (me.filtros.empresas.length > 0) {
        sucs = flatMap(me.sucursalesParaFiltro, (suc) => { return suc._id })
      }
      let res = me.allResults
      if (sucs.length > 0) {
        res = filter(me.allResults, (respuesta) => {
          return sucs.indexOf(respuesta.usuario.sucursalAsociada._id) >= 0
        })
      }
      me.results = res
      let groupedByPregunta = groupBy(res, (p) => { return p.pregunta._id })
      me.resultsGroupedByQuestion = groupedByPregunta
      let resultados = []
      me.preguntas.forEach((pregunta) => {
        if (pregunta.tipo === 'Rating') {
          let res = {pregunta: pregunta.pregunta, preguntaId: pregunta._id, tipo: pregunta.tipo, values: [], names: ['Bueno', 'Regular', 'Malo']}
          let ones = 0
          let twos = 0
          let threes = 0
          if (groupedByPregunta[pregunta._id]) {
            groupedByPregunta[pregunta._id].forEach((resp) => {
              if (resp.respuestaNumero === 1) {
                ones++
              }
              if (resp.respuestaNumero === 2) {
                twos++
              }
              if (resp.respuestaNumero === 3) {
                threes++
              }
            })
            res.values.push(threes)
            res.values.push(twos)
            res.values.push(ones)
            resultados.push(res)
          }
        }
      })
      return resultados
    }
  },
  methods: {
    getRespuesta (resp) {
      let ans = ''
      if (resp.respuestaNumero) {
        switch (resp.respuestaNumero) {
          case 1:
            ans = 'Malo'
            break
          case 2:
            ans = 'Regular'
            break
          case 3:
            ans = 'Bueno'
            break
        }
      } else {
        ans = resp.respuestaString
      }
      return ans
    },
    quitarFiltrosEmpresa () {
      const me = this
      me.filtros.empresas = []
      $(me.$refs.slEmpresa).val(me.filtros.empresas).trigger('change')
    },
    quitarFiltrosSucursal () {
      const me = this
      me.filtros.sucursales = []
      $(me.$refs.slSucursal).val(me.filtros.sucursales).trigger('change')
    },
    dataFormat (a, b) {
      const me = this
      if (b) return Math.floor((b / me.answers) * 100) + ' %'
      return ''
    },
    getSucursalesEmpresa (empresa) {
      const me = this
      let sucursales = filter(me.camp.sucursales, {empresa: empresa._id})
      if (!sucursales) {
        return ''
      } else {
        sucursales = flatMap(sucursales, (suc) => { return suc.denominacion })
        return sucursales.join(',')
      }
    },
    eliminarEmpresa (idx) {
      const me = this
      let emp = me.camp.empresas[idx]
      let sucIdx = findIndex(me.camp.sucursales, {empresa: emp._id})
      while (sucIdx >= 0) {
        me.camp.sucursales.splice(sucIdx, 1)
        sucIdx = findIndex(me.camp.sucursales, {empresa: emp._id})
      }
      me.camp.empresas.splice(idx, 1)
    },
    guardarSucursales () {
      const me = this
      me.camp.sucursales = me.campActiva.sucursales
      me.campActiva = undefined
      $(me.$refs.modalSucursal).modal('hide')
    },
    guardarEmpresas () {
      const me = this
      me.campActiva.empresasSelect.forEach((emp) => {
        if (findIndex(me.camp.empresas, {_id: emp}) < 0) {
          me.camp.empresas.push(find(me.empresas, {_id: emp}))
          me.sucursales.forEach((suc) => {
            if (suc.empresa._id === emp && findIndex(me.campActiva.sucursales, {_id: suc._id}) < 0) {
              me.campActiva.sucursales.push({_id: suc._id, denominacion: suc.denominacion, empresa: emp})
            }
          })
        }
      })
      me.camp.empresas.forEach((emp, idx) => {
        if (me.campActiva.empresasSelect.indexOf(emp._id) < 0) {
          me.camp.empresas.splice(idx, 1)
          me.campActiva.sucursales.forEach((suc, sucIdx) => {
            if (suc.empresa === emp._id) {
              me.campActiva.sucursales.splice(sucIdx, 1)
            }
          })
        }
      })
      me.camp.sucursales = me.campActiva.sucursales
      me.campActiva = undefined
      $(me.$refs.modalCambiarEmpresas).modal('hide')
    },
    toggleEmpresa (empresa) {
      const me = this
      let idx = findIndex(me.campActiva.empresas, {_id: empresa._id})
      if (idx < 0) {
        me.campActiva.empresas.push(empresa)
        me.sucursales.forEach((suc) => {
          if (suc.empresa._id === empresa._id && findIndex(me.campActiva.sucursales, {_id: suc._id}) < 0) {
            me.campActiva.sucursales.push({_id: suc._id, denominacion: suc.denominacion, empresa: empresa._id})
          }
        })
      } else {
        me.campActiva.empresas.splice(idx, 1)
        empresa.sucursales.forEach((suc) => {
          if (suc.empresa._id === empresa._id) {
            let sucIdx = findIndex(me.campActiva.sucursales, {_id: suc._id})
            if (sucIdx >= 0) {
              me.campActiva.sucursales.splice(sucIdx, 1)
            }
          }
        })
      }
    },
    empresaSeleccionada (emp) {
      const me = this
      return findIndex(me.campActiva.empresas, {_id: emp._id}) >= 0
    },
    exportXls (grouped, question) {
      const me = this
      let title = me.camp.name + ' | Creada: ' + moment(me.camp.fechaCreacion).format('DD/MM/YYYY')
      title += ' | Vigente desde: ' + moment(me.camp.fechaInicio).format('DD/MM/YYYY')
      title += ' | ' + me.camp.activo ? 'Activa' : 'Inactiva'
      let subtitle = 'Alcance: ' + me.reach + ' | Respuestas: ' + me.answers
      let html = ''
      if (!grouped) {
        html = `<table class="table" id="tblExport">
        <thead>
          <tr>
            <th colspan='7'>${title}</th>
          </tr>
          <tr>
            <th colspan='7'>${subtitle}</th>
          </tr>
          <tr>
            <th>Nick</th>
            <th>Nombre</th>
            <th>Email</th>
            <th>Empresa - Sucursal</th>
            <th>Pregunta</th>
            <th>Respuesta</th>
            <th>Fecha</th>
          </tr>
        </thead>
        <tbody>
          ${me.results.map(res => {
            return `<tr>
              <td>${res.usuario.username}</td>
              <td>${res.usuario.displayName}</td>
              <td>${res.usuario.email}</td>
              <td>${res.usuario.sucursalAsociada.empresa.razonSocial} - ${res.usuario.sucursalAsociada.denominacion}</td>
              <td>${res.pregunta.pregunta}</td>
              <td>${me.getRespuesta(res)}</td>
              <td>${moment(res.fechaCreacion).format('DD/MM/YYYY HH:mm')}</td>
            </tr>`
          })
          }
        </tbody>
      </table>`
      } else {
        let qs = me.preguntas
        if (question) {
          qs = [question]
        }
        html = `<table class="table" id="tblExport">
        <thead>
          <tr>
            <th colspan='5'>${title}</th>
          </tr>
          <tr>
            <th colspan='5'>${subtitle}</th>
          </tr>
        </thead>
        <tbody>
          ${qs.map(preg => {
            return `
            <tr>
              <th colspan="5">${preg.pregunta}</th>
            </tr>            
            <tr>
              <th>Nick</th>
              <th>Nombre</th>
              <th>Email</th>
              <th>Empresa - Sucursal</th>
              <th>Respuesta</th>
            </tr>
            ${me.resultsGroupedByQuestion[preg._id].map(res => {
              return `
              <tr>
                <td>${res.usuario.username}</td>
                <td>${res.usuario.displayName}</td>
                <td>${res.usuario.email}</td>
                <td>${res.usuario.sucursalAsociada.empresa.razonSocial} - ${res.usuario.sucursalAsociada.denominacion}</td>
                <td>${me.getRespuesta(res)}</td>
              </tr>`
            })
            }
            `
          })
          }
        </tbody>
      </table>`
      }
      $(me.$refs.contenedorExport).html(html)
      let table = document.getElementById('tblExport')
      let tableExp = new TableExport(table, {
        exportButtons: false,
        formats: ['xls', 'csv', 'txt', 'xlsx']
      })
      tableExp.types.date.assert = function (v) {
        return false
      }
      let exportData = tableExp.getExportData()
      tableExp.export2file(exportData.tblExport.xlsx.data, 'applicationvnd.openxmlformats-officedocument.spreadsheetml.sheet', 'Campania-' + me.camp.name, '.xlsx')
    },
    exportPdf (question) {
      const me = this
      let qs = me.preguntas
      if (question) {
        qs = [question]
      }
      var img = new Image()
      img.src = '/images/bird.png'
      img.onload = function () {
        let graphs = []
        let graphElems = $('.piegraph svg')
        if (question) {
          graphElems = $('.piegraph.' + question._id + ' svg')
        }
        graphElems.each((idx, graphElem) => {
          let elem = $('<div />')
          elem.append($(graphElem).clone())
          let svg = elem.html()
          svg = svg.replace(/\r?\n|\r/g, '').trim()
          var canvas = document.createElement('canvas')
          canvg(canvas, svg)
          let imgData = canvas.toDataURL('image/png')
          graphs.push(imgData)
        })
        let title = me.camp.name + ' | Creada: ' + moment(me.camp.fechaCreacion).format('DD/MM/YYYY')
        title += ' | Vigente desde: ' + moment(me.camp.fechaInicio).format('DD/MM/YYYY') + ' | '
        title += me.camp.activo ? 'Activa' : 'Inactiva'
        let subtitle = 'Alcance: ' + me.reach + ' | Respuestas: ' + me.answers
        const columns = ['Nick', 'Usuario', 'Email', 'Empresa - Sucursal', 'Respuesta']
        const doc = new JsPDF('l')
        let margin = 25
        doc.addImage(img, 'PNG', 25, 10, 12, 12)
        doc.setFontSize(12)
        doc.text(title, 40, 14)
        doc.setFontSize(10)
        doc.text(subtitle, 40, 19)
        let pageSize = doc.internal.pageSize
        let pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
        let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        let imageWidth = (pageWidth - 20) / 4
        if (graphs.length > 0) {
          margin = pageHeight
        }
        graphs.forEach((gr, idx) => {
          let row = Math.floor(idx / 4)
          let col = idx % 4
          doc.addImage(gr, 'PNG', 10 + (col * imageWidth), 25 + (row * imageWidth), imageWidth, imageWidth)
        })
        doc.setFontSize(7)
        qs.forEach((preg, idx) => {
          if (preg.tipo === 'Rating') {
            let row = Math.floor(idx / 4)
            let col = idx % 4
            let text = doc.splitTextToSize(preg.pregunta, imageWidth)
            doc.text(text, 10 + (col * imageWidth), 35 + (row * imageWidth), {align: 'center', maxWidth: 2})
          }
        })
        doc.addImage(img, 'PNG', 25, margin + 10, 12, 12)
        doc.setFontSize(12)
        doc.text(title, 40, 14 + margin)
        doc.setFontSize(10)
        doc.text(subtitle, 40, 19 + margin)
        qs.forEach((preg, idx) => {
          let rows = [columns]
          me.resultsGroupedByQuestion[preg._id].map((res) => {
            rows.push([
              res.usuario.username,
              res.usuario.displayName,
              res.usuario.email,
              res.usuario.sucursalAsociada.empresa.razonSocial + ' - ' + res.usuario.sucursalAsociada.denominacion,
              me.getRespuesta(res)
            ])
          })
          doc.setFontSize(10)
          doc.autoTable([preg.pregunta, '', '', '', ''], rows, {
            margin: 15,
            startY: idx === 0 ? margin : doc.autoTable.previous.finalY + 5,
            bodyStyles: {
              overflow: 'linebreak',
              overflowColumns: 'linebreak',
              fontSize: 8,
              columnWidth: 'wrap'
            },
            headerStyles: {
              fillColor: [147, 165, 18]
            },
            addPageContent: function (data) {
            }
          })
        })
        doc.save('campania-' + me.camp.name + '.pdf')
      }
    },
    toggleSucursal (sucursal) {
      const me = this
      let idx = findIndex(me.campActiva.sucursales, {_id: sucursal._id})
      if (idx < 0) {
        me.campActiva.sucursales.push(sucursal)
      } else {
        me.campActiva.sucursales.splice(idx, 1)
      }
    },
    sucursalSeleccionada (sucursal) {
      const me = this
      return findIndex(me.campActiva.sucursales, {_id: sucursal._id}) >= 0
    },
    onClickCambiarEmpresas () {
      const me = this
      me.campActiva = cloneDeep(me.camp)
      $(me.$refs.modalCambiarEmpresas).modal()
    },
    onClickCambiarSucursales (empresa) {
      const me = this
      me.empresaActiva = empresa
      me.campActiva = cloneDeep(me.camp)
      me.loadingSucursales = true
      me.$http.get('/api/admin/empresa/sucursales', {
        params: {
          id: empresa._id
        }
      }).then(({body}) => {
        me.loadingSucursales = false
        me.sucursales = body.sucursales
      })
      $(me.$refs.modalSucursal).modal()
    },
    cambiarEstadoActivo (id, valor) {
      const me = this
      me.$http.post('/api/admin/cambiarestadoactivo', {
        valor: valor,
        id: id
      }).then(({body}) => {
        let usuarioCambiado = me.usuarios.find((usuario) => {
          return usuario._id === id
        })
        usuarioCambiado.activado = valor
      }, (err) => {
        console.error(err)
      })
    },
    clearAsignacion () {
      const me = this
      me.proveedorSeleccionado = null
      me.asignacion = {
        comboSeleccionado: null,
        horarioSeleccionado: null,
        proveedorActivo: null
      }
      me.sucursal.subsidio = {
        comboAsignado: null,
        lunes: 0,
        martes: 0,
        miércoles: 0,
        jueves: 0,
        viernes: 0,
        sábado: 0,
        domingo: 0
      }
    },
    clearSucursal () {
      const me = this
      me.sucursal = {
        _id: null,
        denominacion: '',
        proveedoresAsociados: [],
        proveedores: [],
        subsidio: {
          comboAsignado: null,
          lunes: 0,
          martes: 0,
          miércoles: 0,
          jueves: 0,
          viernes: 0,
          sábado: 0,
          domingo: 0
        }
      }
      me.idxSucursalEditada = -1
      me.clearDireccion()
      me.clearAsignacion()
    },
    clearDireccion () {
      const me = this
      me.direccion = {
        direccion: '',
        direccionFormateada: '',
        latitud: 0,
        longitud: 0,
        torre: '',
        piso: '',
        departamento: ''
      }
      me.$refs.direccion.clear()
    },
    clickCrearSucursal () {
      const me = this
      me.clearSucursal()
      $('.nav-tabs a[href="#form-sucursal"]').tab('show')
    },
    clickGuardarUsuario () {
      const me = this
      let data = me.usuario
      me.errors = []
      data.sucursalAsociada = me.idSucursalEdicion
      me.$http.post('/api/admin/crearusuariocliente', data).then(({body}) => {
        me.idSucursalEdicion = null
        me.nombreSucursalEdicion = ''
        me.$emit('mostrar-notificacion', 'El usuario fue creado correctamente', 'success')
        me.$router.push({
          path: '/clientes'
        })
      }, (err) => {
        me.errors = err.body
      })
    },
    copiarATodos (valorDia) {
      const me = this
      let val = valorDia
      Object.assign(me.sucursal.subsidio, {
        lunes: val,
        martes: val,
        miércoles: val,
        jueves: val,
        viernes: val,
        sábado: val
      })
    },
    getAddressData (e, place) {
      const me = this
      me.direccion = {
        latitud: e.latitude,
        longitud: e.longitude,
        direccion: place.name,
        direccionFormateada: place.formatted_address,
        torre: me.direccion.torre,
        piso: me.direccion.piso,
        departamento: me.direccion.departamento
      }
      console.log('direccion', me.direccion)
    },
    onChangeProveedor (e) {
      const me = this
      me.asignacion.comboSeleccionado = null
      me.asignacion.horarioSeleccionado = null
      me.proveedorSeleccionado = me.proveedores.find((proveedor) => {
        return proveedor._id === e.target.value
      })
    },
    onClickCambiarActivo (id, valor) {
      const me = this
      swal({
        title: 'Confirme operación',
        text: '¿Desea cambiar el estado del usuario seleccionado?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'No, dejar sin efecto'
      }).then(() => {
        me.cambiarEstadoActivo(id, valor)
      }, (dismiss) => {
        return false
      })
    },
    onClickEliminarProveedor (idx) {
      const me = this
      swal({
        title: 'Confirme operación',
        text: '¿Desea eliminar el proveedor asignado?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'No, dejar sin efecto'
      }).then(() => {
        me.sucursal.proveedores.splice(idx, 1)
      }, (dismiss) => {
        return false
      })
    },
    onClickGuardarSucursal () {
      const me = this
      let sucursal = Object.assign({}, me.sucursal)
      sucursal.direccion = Object.assign({}, me.direccion)
      sucursal.idEmpresaCliente = me.cliente._id
      me.$http.post('/api/admin/sucursales', sucursal).then(({body}) => {
        let sucursal = body
        let existeSucursal = me.sucursales.find((sucursalEnCliente) => {
          return sucursal._id === sucursalEnCliente._id
        })
        if (!existeSucursal) {
          me.sucursales.push(body)
        } else {
          existeSucursal = sucursal
        }
        me.editandoSucursalGuardada = false
        me.clearSucursal()
        $('.nav-tabs a[href="#sucursales"]').tab('show')
      }, (err) => {
        console.error(err)
      })
    },
    onClickModificar (asignacion, idx) {
      console.log('onClickModificar', asignacion, idx)
      const me = this
      me.asignacion.proveedorActivo = asignacion.proveedor
      me.proveedorSeleccionado = me.proveedores.find((proveedor) => {
        return proveedor._id === asignacion.proveedor
      })
      me.asignacion.comboSeleccionado = asignacion.combo
      me.asignacion.horarioSeleccionado = asignacion.horarioAsignado
      me.sucursal.subsidio = asignacion.subsidio
      me.editandoProveedorSucursal = true
      me.idxSucursalEditada = idx
    },
    onGuardarCampaign () {
      const me = this
      if (!me.$v.camp.$invalid && me.camp.empresasSelect.length > 0 && me.camp.sucursalesSelect.length > 0) {
        me.camp.preguntas = me.preguntas
        me.camp.sucursales = filter(me.sucursales, (suc) => { me.camp.sucursalesSelect.indexOf(suc._id) >= 0 })
        me.camp.empresas = filter(me.empresas, (emp) => { me.camp.empresasSelect.indexOf(emp._id) >= 0 })
        me.$http.post('/api/admin/campaign', me.camp).then(({body}) => {
          me.$emit('mostrar-notificacion', 'La campaña se ha guardado', 'success')
          me.$router.push({path: '/campaigns'})
        }, (err) => {
          console.error(err)
        })
      } else {
        me.$emit('mostrar-notificacion', 'Se necesita ingresar el nombre, fechas de inicio y fin, y tener por lo menos una sucursal', 'warning')
      }
    },
    agregarTodasLasEmpresas () {
      const me = this
      me.camp.empresas = me.empresas
      me.camp.empresasSelect = flatMap(me.empresas, (emp) => { return emp._id })
      $(me.$refs.slEmpresasActiva).val(me.camp.empresasSelect).trigger('change')
    },
    quitarTodasLasEmpresas () {
      const me = this
      me.camp.empresas = []
      me.camp.empresasSelect = []
      $(me.$refs.slEmpresasActiva).val(me.camp.empresasSelect).trigger('change')
    },
    quitarTodasLasSucursales () {
      const me = this
      me.camp.sucursales = []
      me.camp.sucursalesSelect = []
      $(me.$refs.slSucursalesActiva).val(me.camp.sucursalesSelect).trigger('change')
    },
    agregarTodasLasSucursales () {
      const me = this
      me.camp.sucursales = me.sucursalesParaSelect
      me.camp.sucursalesSelect = flatMap(me.camp.sucursales, (emp) => { return emp._id })
      $(me.$refs.slSucursalesActiva).val(me.camp.sucursalesSelect).trigger('change')
    },
    idAProveedor (value) {
      const me = this
      let resultado = ''
      let proveedor = me.proveedores.find((proveedor) => {
        return proveedor._id === value
      })
      if (proveedor) {
        resultado = proveedor.razonSocial
      }
      return resultado
    },
    idComboATexto (idCombo, idProveedor) {
      const me = this
      let prov = me.proveedores.find((proveedor) => {
        return proveedor._id === idProveedor
      })
      let precio = prov.precios.find((precio) => {
        return precio.combo._id === idCombo
      })
      return precio.combo.nombre
    },
    setSucursalActiva (id) {
      const me = this
      me.sucursal = me.sucursales.find((sucursal) => {
        return sucursal._id === id
      })
      me.direccion = me.sucursal.direccion
      me.$refs.direccion.update(me.direccion.direccionFormateada)
      me.editandoSucursalGuardada = true
      me.clearAsignacion()
      $('.nav-tabs a[href="#form-sucursal"]').tab('show')
    },
    setSucursalEdicion (sucursal) {
      const me = this
      me.idSucursalEdicion = sucursal._id
      me.nombreSucursalEdicion = sucursal.denominacion.toUpperCase()
      $('.nav-tabs a[href="#form-usuario"]').tab('show')
    },
    agregarProveedor () {
      const me = this
      me.mostrarErroresProveedor = false
      if (me.$v.asignacion.$invalid) {
        console.log('asignacion no valida')
        me.mostrarErroresProveedor = true
        return false
      }
      let existeProveedorCombo = me.sucursal.proveedores.find((item) => {
        return item.proveedor === me.asignacion.proveedorActivo && item.combo === me.asignacion.comboSeleccionado
      })
      if (existeProveedorCombo) {
        me.$emit('mostrar-notificacion', 'Ya existe ese combo y proveedor', 'error')
        return false
      }
      let subsidio = Object.assign({}, me.sucursal.subsidio)
      subsidio.comboAsignado = me.asignacion.comboSeleccionado
      let itemProveedor = {
        proveedor: me.asignacion.proveedorActivo,
        combo: me.asignacion.comboSeleccionado,
        horarioAsignado: me.asignacion.horarioSeleccionado,
        subsidio: subsidio
      }
      if (me.idxSucursalEditada > -1) {
        me.sucursal.proveedores.splice(me.idxSucursalEditada, itemProveedor)
      } else {
        me.sucursal.proveedores.push(itemProveedor)
      }
      me.clearAsignacion()
    }
  }
}
</script>



// WEBPACK FOOTER //
// New.vue?8c33a9bc